export enum TIME_FORMAT {
  TIME_GUTTER_PICKER_HH_SS = 'h:mm a',
  TIME_PICKER_HH_SS = 'HH:mm',
  TIME_PICKER_YYYY_MM_DD_HH_SS = 'YYYY-MM-DD HH:mm',
  TWELVE_HOUR_FORMAT = 'h:mm a',
  TWELVE_HOUR_FORMAT_WITH_SECONDS = 'h:mm:ss a',
}
